import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Chip, Link, Stack } from "@mui/material";

import ZendeskIcon from "../../assets/zendeskIcon.png";
import { useCustomerId } from "../../Components/hooks/useCustomerId";
import { useAuthContext } from "../../Context/AuthContext";
import SupportItemIcon from "../../Support/Components/SupportItemIcon";
import { getStatusColor } from "../../Support/Components/TicketsFilterTable/TicketsTableColumns";
import { type Ticket } from "../../Support/types";
import { transformStatus } from "../../utils/common";
import { useAvaDialogContext } from "./AvaDialogContextProvider";
import { getPlatformId, openTicketInZendesk } from "./utils";

export const RecentTicketRow = ({ ticket }: { ticket: Ticket }) => {
  const customerId = useCustomerId();
  const { handleCloseAvaDialog } = useAvaDialogContext();

  const { isDoitEmployee } = useAuthContext();

  const { t } = useTranslation("services");

  const platform = getPlatformId(ticket);

  return (
    <Stack
      direction="row"
      spacing={1}
      flex={1}
      alignSelf="flex-start"
      sx={{ borderBottom: "1px solid", borderColor: "divider", py: 2 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1}>
        {isDoitEmployee ? (
          <Link
            href="#"
            onClick={() => {
              openTicketInZendesk(ticket.id);
            }}
            data-cy={`ticketRow-${ticket.id}-zendDesk`}
          >
            <img alt="zendesk icon" style={{ width: 20, height: 20 }} src={ZendeskIcon} />
          </Link>
        ) : (
          <SupportItemIcon platformValue={platform} />
        )}
        <Link
          color="inherit"
          component={RouterLink}
          to={`/customers/${customerId}/support/tickets/${ticket.id}`}
          underline="always"
          variant="body2"
          onClick={handleCloseAvaDialog}
          sx={{ mr: 1 }}
        >
          {ticket.id}
        </Link>
        <Link
          color="inherit"
          component={RouterLink}
          to={`/customers/${customerId}/support/tickets/${ticket.id}`}
          underline="always"
          variant="body2"
          onClick={handleCloseAvaDialog}
        >
          {ticket.subject}
        </Link>
      </Stack>
      <Chip variant="status" color={getStatusColor(ticket.status)} label={transformStatus(ticket.status, t)} />
    </Stack>
  );
};
